
import hempSearch from "./search-queries/search-cannabis-US";

export default [hempSearch];
